import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import { getDictionary } from 'store/services/dictionaries/selectors';
import * as api from './api';
import * as types from './actionTypes';

/**
 * Add a new Dictionary Column
 *
 * @param data
 */
export const addDictionaryColumn = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.ADD_DICTIONARY_COLUMN_REQUEST,
    });

    const dictionaryId = getDictionary(getState()).id;

    await api.addDictionaryColumnRequest(dictionaryId, data);

    dispatch({
      type: types.ADD_DICTIONARY_COLUMN_SUCCESS,
    });

    const response = await api.getDictionaryColumnsRequest(dictionaryId);

    dispatch({
      type: types.GET_DICTIONARY_COLUMNS_SUCCESS,
      payload: {
        dictionaryColumns: response.data.results,
        count: response.data.count,
      },
    });

    Notify.success({
      title: 'Dictionary Column was created successfully',
    });
  } catch (error) {
    dispatch({
      type: types.ADD_DICTIONARY_COLUMN_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'Fail to create Dictionary Column',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

/**
 * Update Dictionary Column
 *
 * @param id
 * @param data
 */
export const updateDictionaryColumn = (id, data) => async (
  dispatch,
  getState,
) => {
  try {
    await dispatch({
      type: types.UPDATE_DICTIONARY_COLUMN_REQUEST,
    });

    const dictionaryId = getDictionary(getState()).id;

    await api.updateDictionaryColumnRequest(dictionaryId, id, data);

    dispatch({
      type: types.UPDATE_DICTIONARY_COLUMN_SUCCESS,
    });

    const response = await api.getDictionaryColumnsRequest(dictionaryId);

    dispatch({
      type: types.GET_DICTIONARY_COLUMNS_SUCCESS,
      payload: {
        dictionaryColumns: response.data.results,
        count: response.data.count,
      },
    });

    Notify.success({
      title: 'Dictionary Column was updated successfully',
    });
  } catch (error) {
    dispatch({
      type: types.UPDATE_DICTIONARY_COLUMN_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'Fail to update Dictionary Column',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

/**
 * Delete a Dictionary Column
 *
 * @param id
 */
export const deleteDictionaryColumn = id => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.DELETE_DICTIONARY_COLUMN_REQUEST,
    });

    const dictionaryId = getDictionary(getState()).id;

    await api.deleteDictionaryColumnRequest(dictionaryId, id);

    dispatch({
      type: types.DELETE_DICTIONARY_COLUMN_SUCCESS,
    });

    const { data } = await api.getDictionaryColumnsRequest(dictionaryId);

    dispatch({
      type: types.GET_DICTIONARY_COLUMNS_SUCCESS,
      payload: {
        dictionaryColumns: data.results,
        count: data.count,
      },
    });

    Notify.success({
      title: 'Dictionary Column was deleted successfully',
    });
  } catch (error) {
    dispatch({
      type: types.DELETE_DICTIONARY_COLUMN_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'Fail to delete Dictionary Column',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};
